import {LabQualityResultPage as LabQualityResultPageFeature} from '@features/lab-quality-result'
import {UpmPlantProvider, useUpmPlant} from '@hconnect/upm'
import {useParams} from 'react-router'

export const LabQualityResultPage = () => {
  const {plantId} = useParams<{plantId: string}>()
  if (!plantId) throw new Error('plantId is required')

  // Cockpit resolves the SAP plantId → upmId via the sanctioned bridge under the global
  // UpmPlantsProvider, then provides the singular plant context the feature's leaves consume.
  const {upmId} = useUpmPlant({plantId})

  return (
    <UpmPlantProvider plantUpmId={upmId}>
      <LabQualityResultPageFeature plantId={plantId} inverted />
    </UpmPlantProvider>
  )
}
